import request from '@hubble/request';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import Analytics from 'site-react/core/Analytics';
import Curve from 'site-react/core/Curve';
import logError from 'site-react/core/helpers/logError';

import Error from '../../_error';
import PageLayout from '../../../layouts/PageLayout';
import { Survey } from 'site-react/features/Survey';

const SurveyPage = ({ results = null, error = null }) => {
  const meta = {
    title: 'Should We Ditch the Office? Survey Results',
    description:
      'HubbleHQ asked over 1,000 employees how they worked before coronavirus, how they’re working right now, and how they want to work in the future. This is what they said.',
    img:
      'https://hubble.imgix.net/site/should-we-ditch-the-office-survey/meta/should-we-ditch-the-office-blog.png?auto=compress',
  };

  useEffect(() => {
    Analytics.setPageProperties({
      page_category: 'survey',
      page_type: 'survey-aggregate',
      survey_name: 'should-we-ditch-the-office',
    });

    Analytics.pageTrack('Survey');
  }, []);

  return error ? (
    <Error statusCode={error.statusCode || 500} />
  ) : (
    <PageLayout meta={meta} isNavigationHidden isPageBannerHidden>
      <Survey results={results} count={1046} />
      <Curve bottomColor="neutral900" topColor="gradientBlue" type="wave" />
    </PageLayout>
  );
};

SurveyPage.getInitialProps = async (res) => {
  try {
    const results = await request(
      'https://hbl-public-assets.s3.eu-west-2.amazonaws.com/surveys/should-we-ditch-the-office/aggregate-results.json',
    );

    return { results: results.body };
  } catch (error) {
    logError(error);
    return { error: { statusCode: error.statusCode } };
  }
};

SurveyPage.propTypes = {
  /**
   * Array of survey result objects
   */
  results: PropTypes.array,

  /**
   * Object returned if an error is thrown getting the posts. Contains an HTTP
   * status code if available.
   */
  error: PropTypes.shape({ statusCode: PropTypes.number }),
};

export default SurveyPage;
